import request from '../utils/request';

export function transStatus(data) {
  return request({
    url: '/api/get-trans-status',
    method: 'post',
    data,
  });
}

/** 读取某个预测产品已有的 AI 评估（不触发外部调用） */
export function aiInsight(data) {
  return request({
    url: '/api/ai/insight',
    method: 'post',
    data,
  });
}

/** 获取 AI 评估，必要时触发生成（data.refresh = true 强制刷新） */
export function aiEvaluate(data) {
  return request({
    url: '/api/ai/evaluate',
    method: 'post',
    data,
  });
}

/* ------------------- 增长功能：战绩榜 / 出租市场 / 推广中心 ------------------- */

/** 战绩排行榜。sort: roi|win_rate|volume|profit|bets；period: all|7d|30d|90d */
export function leaderboard(data) {
  return request({
    url: '/api/leaderboard',
    method: 'post',
    data,
  });
}

/** 交易员主页：战绩汇总 + 最近战绩 + 当前在售/在租票据（用于一键跟单） */
export function traderProfile(data) {
  return request({
    url: '/api/trader',
    method: 'post',
    data,
  });
}

/** 出租市场挂单。sort: daily|term|price|newest */
export function rentalList(data) {
  return request({
    url: '/api/rental/list',
    method: 'post',
    data,
  });
}

/** 出租成交记录 */
export function rentalDeals(data) {
  return request({
    url: '/api/rental/deals',
    method: 'post',
    data,
  });
}

/** 某地址的租金收支 */
export function rentalIncome(data) {
  return request({
    url: '/api/rental/income',
    method: 'post',
    data,
  });
}

/** 推广总览（推荐人数 + 返佣合计） */
export function referralSummary(data) {
  return request({
    url: '/api/referral/summary',
    method: 'post',
    data,
  });
}

/** 我的推荐列表 */
export function referralInvitees(data) {
  return request({
    url: '/api/referral/invitees',
    method: 'post',
    data,
  });
}

/** 返佣流水 */
export function referralRewards(data) {
  return request({
    url: '/api/referral/rewards',
    method: 'post',
    data,
  });
}

/** 推广榜 */
export function referralTop(data) {
  return request({
    url: '/api/referral/top',
    method: 'post',
    data,
  });
}

/* ---------- 推荐奖励（推荐返佣 + 团队 + VIP） ---------- */

/** 我的推荐奖励概览：模式 / 费率 / 两级上级 / 团队 / 奖励合计 / VIP */
export function distributionMy(data) {
  return request({
    url: '/api/distribution/my',
    method: 'post',
    data,
  });
}

/** 我的团队结构（各层人数 + 成员） */
export function distributionTeam(data) {
  return request({
    url: '/api/distribution/team',
    method: 'post',
    data,
  });
}

/** 佣金明细（按层级 / 状态过滤） */
export function distributionCommissions(data) {
  return request({
    url: '/api/distribution/commissions',
    method: 'post',
    data,
  });
}

/** 我的 VIP 等级与升级进度 */
export function distributionVip(data) {
  return request({
    url: '/api/distribution/vip',
    method: 'post',
    data,
  });
}

/** VIP 奖池周期与我的分配 */
export function distributionPools(data) {
  return request({
    url: '/api/distribution/pools',
    method: 'post',
    data,
  });
}

/** 我的推荐关系绑定状态（上级 L1/L2、绑定来源） */
export function distributionReferrerStatus(data) {
  return request({
    url: '/api/distribution/referrer-status',
    method: 'post',
    data,
  });
}

/* ---------- 个人中心：资金与收益（v1.2 §5，只读） ---------- */

/** §5.1 资金总览：可用/占用/未结算成本/估值/未实现/已实现/累计费用/推荐收入 */
export function accountFunds(data) {
  return request({
    url: '/api/account/funds',
    method: 'post',
    data,
  });
}

/** §5.2 交易/参与明细（逐笔含费用分栏） */
export function accountActivities(data) {
  return request({
    url: '/api/account/activities',
    method: 'post',
    data,
  });
}

/** §5.3 结算与收益明细（按已结算产品聚合） */
export function accountSettlements(data) {
  return request({
    url: '/api/account/settlements',
    method: 'post',
    data,
  });
}

/** 动作类型字典（明细筛选下拉） */
export function accountActionTypes(data) {
  return request({
    url: '/api/account/action-types',
    method: 'post',
    data,
  });
}

/* ---------- 推荐奖励中心（referral_reward_items 明细口径） ---------- */

/** 奖励汇总：累计/待确认/已发放/已撤销/可领取 */
export function rewardSummary(data) {
  return request({
    url: '/api/distribution/reward-summary',
    method: 'post',
    data,
  });
}

/** 奖励明细（分页 + 板块/来源/状态/日期筛选） */
export function rewardItems(data) {
  return request({
    url: '/api/distribution/rewards',
    method: 'post',
    data,
  });
}

/* ---------- Fixed-Odds 用户注单提前退出（v1.9.16，D4/D6 估值公式） ---------- */

/** 用户注单提前退出试算：YES 免责窗口+时间平方 / NO 可用额度占比²+时间² */
export function fixedOddsUserExitPreview(data) {
  return request({
    url: '/api/fixed-odds/user-exit-preview',
    method: 'post',
    data,
  });
}

/** 用户注单提前退出执行（整单、幂等、偿付能力硬闸） */
export function fixedOddsUserExit(data) {
  return request({
    url: '/api/fixed-odds/user-exit',
    method: 'post',
    data,
  });
}

export function eventMaket(data) {
  return request({
    url: '/api/markets',
    method: 'post',
    data,
  });
}

/**
 * 批量行情快照：只回各选项的隐含价格与持仓，供列表页按间隔增量刷新。
 * @param {{chain: number, ids: number[]}} data
 */
export function marketTickers(data) {
  return request({
    url: '/api/market/tickers',
    method: 'post',
    data,
  });
}

/** 四个板块概览（可参与产品数 + 最新产品时间），供导航下拉与「有新内容」红点判定 */
export function eventTypes(data) {
  return request({
    url: '/api/market/types',
    method: 'post',
    data,
  });
}

export function eventDetail(data) {
  return request({
    url: '/api/market/detail',
    method: 'post',
    data,
  });
}

export function tickets(data) {
  return request({
    url: '/api/ticket/tokens',
    method: 'post',
    data,
  });
}

/**
 * 多链元数据（v2.1.0）。
 * v2.4.0 起每条链带上 `participation`（参与模式），前端据此决定资金入口 ——
 * 不要写死模式，后台可按链切换。
 */
export function chainList(data) {
  return request({
    url: '/api/chains',
    method: 'post',
    data,
  });
}

export function issueConfig(data) {
  return request({
    url: '/api/config/issue',
    method: 'post',
    data,
  });
}

export function issueUnderlying(data) {
  return request({
    url: '/api/issue/submit-underlying',
    method: 'post',
    data,
  });
}
export function upload(data) {
  return request({
    url: '/api/upload',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'post',
    data,
  });
}
export function ticketSale(data) {
  return request({
    url: '/api/ticket-sale/sale',
    method: 'post',
    data,
  });
}

export function ticketMarket(data) {
  return request({
    url: '/api/ticket-market',
    method: 'post',
    data,
  });
}

export function nftDetail(data) {
  return request({
    url: '/api/ticket-market/detail',
    method: 'post',
    data,
  });
}

export function ticketPackets(data) {
  return request({
    url: '/api/ticket-market/packets',
    method: 'post',
    data,
  });
}

export function issued(data) {
  return request({
    url: '/api/issued',
    method: 'post',
    data,
  });
}

export function bought(data) {
  return request({
    url: '/api/bought',
    method: 'post',
    data,
  });
}

export function getUserDealt(data) {
  return request({
    url: '/api/user-dealt',
    method: 'post',
    data,
  });
}
export function actions(data) {
  return request({
    url: '/api/actions',
    method: 'post',
    data,
  });
}

export function ticketBalance(data) {
  return request({
    url: '/api/ticket/balance',
    method: 'post',
    data,
  });
}

export function ticketTransaction(data) {
  return request({
    url: '/api/ticket/transactions',
    method: 'post',
    data,
  });
}

export function getUserInfo(user, chain) {
  return request({
    url: '/api/user/info',
    method: 'post',
    data: {
      user,
      chain,
    },
  });
}

/* ------------------- Price 板块（链下）：行情 / 详情 / 参与 ------------------- */

/** 实时行情（Price 盘旁边的当前价与涨跌幅） */
export function priceQuote(data) {
  return request({
    url: '/api/price/quote',
    method: 'post',
    data,
  });
}

/** Price 盘的板块专有数据：基准价 / 结算价 / 截止时间 / 参与分布 */
export function priceDetail(data) {
  return request({
    url: '/api/price/detail',
    method: 'post',
    data,
  });
}

/** 参与 Price 盘（链下建仓，由后端记账，不需要链上签名） */
export function priceParticipate(data) {
  return request({
    url: '/api/price/participate',
    method: 'post',
    data,
  });
}

/** 我的 Price 持仓 */
export function priceMyPositions(data) {
  return request({
    url: '/api/price/my-positions',
    method: 'post',
    data,
  });
}

/** Price 盘 K 线（详情页走势图，周期 = 产品发行 → 结束） */
export function priceKlines(data) {
  return request({
    url: '/api/price/klines',
    method: 'post',
    data,
  });
}

/* ---------------- Dynamic / Fixed-Odds 板块（链下） ---------------- */

/** Dynamic 盘详情：各选项隐含价格（Σ=1）、池内份额、流动性、结算态 */
export function dynamicDetail(data) {
  return request({
    url: '/api/dynamic/detail',
    method: 'post',
    data,
  });
}

/** Dynamic 试算：买/卖 N 份的成本 / 回收 / 成交后价格 */
export function dynamicQuote(data) {
  return request({
    url: '/api/dynamic/quote',
    method: 'post',
    data,
  });
}

/** Dynamic 买/卖份额（链下记账，不签名） */
export function dynamicTrade(data) {
  return request({
    url: '/api/dynamic/trade',
    method: 'post',
    data,
  });
}

/** Fixed-Odds 盘预览：各选项赔率 / 额度 / 负债 / 剩余可吃注金 */
export function fixedOddsPreview(data) {
  return request({
    url: '/api/fixed-odds/preview',
    method: 'post',
    data,
  });
}

/** Fixed-Odds 下注（锁定当前赔率） */
export function fixedOddsBet(data) {
  return request({
    url: '/api/fixed-odds/bet',
    method: 'post',
    data,
  });
}

/** 我的 Dynamic + Fixed-Odds 链下持仓 */
export function boardMyPositions(data) {
  return request({
    url: '/api/board/my-positions',
    method: 'post',
    data,
  });
}

/**
 * 平台动态（Activity）：四板块参与流水合并时间线。
 * 前端 3 秒轮询；支持 board（classic/dynamic/fixed_odds/price）、user（钱包）筛选。
 */
export function activityFeed(data) {
  return request({
    url: '/api/activity',
    method: 'post',
    data,
  });
}

/** 四个板块的开关状态（创建表单据此决定哪些板块可选、带哪些字段） */
export function boardList(data) {
  return request({
    url: '/api/board/list',
    method: 'post',
    data,
  });
}

/**
 * 链下建盘（Dynamic / Fixed-Odds）：不碰合约、不需要持票。
 * Dynamic 传 liquidity；Fixed-Odds 传 odds[] / capacity[]（与 options 一一对应）。
 */
export function boardIssue(data) {
  return request({
    url: '/api/board/issue',
    method: 'post',
    data,
  });
}

/** Fixed-Odds：对手方（发起人）注入风险资金 —— 把钱搬进该盘的风险占用 */
export function fixedOddsInject(data) {
  return request({
    url: '/api/fixed-odds/inject',
    method: 'post',
    data,
  });
}

/** Fixed-Odds：提前退出试算（不落状态），返回费用拆分与退出后风险资本 */
export function fixedOddsExitPreview(data) {
  return request({
    url: '/api/fixed-odds/exit-preview',
    method: 'post',
    data,
  });
}

/** Fixed-Odds：执行提前退出（幂等 + 偿付能力硬闸） */
export function fixedOddsExit(data) {
  return request({
    url: '/api/fixed-odds/exit',
    method: 'post',
    data,
  });
}

/* ------------------- 资金：测试币水龙头 / 站内转账 ------------------- */

/** 水龙头状态：是否开放、可领代币与数量、下次可领时间 */
export function faucetStatus(data) {
  return request({
    url: '/api/faucet/status',
    method: 'post',
    data,
  });
}

/** 领取测试币（直接进合约余额，不需要 gas / approve） */
export function faucetClaim(data) {
  return request({
    url: '/api/faucet/claim',
    method: 'post',
    data,
  });
}

/**
 * v2.5.0 资金风控开关快照：{ withdraw_enabled, transfer_enabled, trade_enabled, *_note }
 * 用于置灰提现 / 站内转 / 下单入口，并在页面上说明暂停原因。
 */
export function riskStatus(data) {
  return request({
    url: '/api/risk/status',
    method: 'post',
    data,
  });
}

/** 站内转账：合约内划转给另一个钱包地址（不是提现，不上链） */
export function transferAsset(data) {
  return request({
    url: '/api/transfer',
    method: 'post',
    data,
  });
}
